import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TrSpinnerButtonDirectiveModule, TooltipDirectiveModule } from '@toro/common/shared/directives';

import { FirstNamePipeModule, DateISOStringPipeModule } from '@toro/common/shared/pipes';

import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';

import { DialogsService } from '@toro/common/shared/services/dialogs.service';

import { StockCardsComponent } from './stock-cards.component';
import { TrackingCardComponent } from './cards/tracking-card/tracking-card.component';

import { AnalyseCardComponent } from './cards/analyse-card/analyse-card.component';

import { GlobalModule } from '../../global.module';
import { ModalModule } from '@toro/common/shared/components';
import { ComponentsModule } from "../../components/components.module";

@NgModule({
    imports: [
        GlobalModule,
        CommonModule,
        ComponentsModule,
        TrSpinnerButtonDirectiveModule,
        TooltipDirectiveModule,
        SvgIconModule,
        FirstNamePipeModule,
        DateISOStringPipeModule,
        ModalModule,
    ],
    declarations: [
        StockCardsComponent,
        AnalyseCardComponent,
        TrackingCardComponent,
    ],
    exports: [
        StockCardsComponent,
        AnalyseCardComponent,
        TrackingCardComponent,
    ],
    providers: [
        DialogsService,
    ],
    entryComponents: [],
})
export class StockCardsModule { }
